import styled, { css } from "styled-components";
import Button from "@mui/material/Button";

export const CommentsWrapper = styled.div`
    background: #fff;
    border-radius: 4px;
    //  padding: 8px 0;
`;

export const CommentItemWrapper = styled.div`
    margin-bottom: 10px;
`;

export const CommentHeader = styled.div`
    display: flex;
`;
export const CommentHeaderData = styled.div`
    display: flex;
    justify-content: space-between;
    flex-grow: 1;
    margin-left: 10px;
`;
export const CommentItemInner = styled.div`
    display: flex;
    flex-direction: column;
`;

export const CommentItemHeader = styled.div`
    display: flex;
    justify-content: space-between;
    margin-left: 10px;
`;

export const CommentItemUsername = styled.h3(
    ({ theme }) => css`
        color: ${theme.palette.common.darkGray};
        font-family: ${theme.typography.base.main};
        font-size: 13px;
        font-weight: 400;
        margin-top: 7.5px;
    `
);

export const CommentItemBody = styled.div(
    ({ theme }) => css`
        color: ${theme.palette.common.blue};
        font-family: ${theme.typography.base.main};
        font-size: 15px;
        line-height: 1.5;
        font-weight: 400;
        margin: 0 0 0 40px;
        text-align: left;
    `
);

export const ShowMoreBtn = styled.span`
    color: #00f;
    cursor: pointer;
    &:hover {
        text-decoration: underline;
    }
`;

export const CommentFooter = styled.div`
    display: flex;
    margin-left: 25px;
`;

export const LoadMoreComments = styled.div(
    ({ theme }) => css`
        display: flex;
        justify-content: space-between;
        color: ${theme.palette.common.darkGray};
        font-size: 15px;
        line-height: 1.5;
        font-weight: 500;
    `
);

export const LoadMoreCommentsText = styled(Button)(
    ({ theme }) => css`
        &.MuiButton-root {
            text-transform: none;
            color: ${theme.palette.common.gray};
            &:hover {
                background-color: transparent;
                text-decoration: underline;
                color: ${theme.palette.common.darkGray};
            }
            &.MuiButtonBase-root {
                font-size: 15px;
            }
        }
    `
);
